/**
 * 智慧农业云平台 - Vuex状态管理
 * 所属公司：河南农博联信息技术有限公司
 * 开发人员：王健
 * 提交时间：2025年
 */
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    // 当前用户信息
    userInfo: (() => { try { return JSON.parse(localStorage.getItem('userInfo')) || {} } catch (e) { return {} } })(),
    // 当前主题 dark-暗色 light-浅色
    theme: localStorage.getItem('theme') || 'dark',
    // 侧边栏折叠状态
    sidebarCollapsed: false
  },
  getters: {
    userInfo: state => state.userInfo,
    theme: state => state.theme,
    isDark: state => state.theme === 'dark'
  },
  mutations: {
    SET_USER_INFO(state, info) {
      state.userInfo = info
      localStorage.setItem('userInfo', JSON.stringify(info))
    },
    SET_THEME(state, theme) {
      state.theme = theme
      localStorage.setItem('theme', theme)
    },
    SET_SIDEBAR_COLLAPSED(state, val) {
      state.sidebarCollapsed = val
    }
  },
  actions: {
    logout({ commit }) {
      localStorage.removeItem('token')
      localStorage.removeItem('userInfo')
      commit('SET_USER_INFO', {})
    }
  }
})
